'use client'
import React, { useEffect, useRef } from 'react'
import wagonBg from '@assets/images/wagonWheelBg.png'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
function WagonWheelChart({ data, isScorecard = false }) {
  const svgRef = useRef(null)

  useEffect(() => {
    drawWagonWheel(data)
  }, [data])

  function drawWagonWheel(data) {
    const element = document?.getElementById('wagonWheel')
    const svg = svgRef.current
    if (!svg || !element) return

    svg.innerHTML = ''

    const centerX = svg.clientWidth / 2
    const centerY = svg.clientHeight / 2

    // Draw shots
    data?.forEach(type => {
      type?.list?.forEach(shot => {
        const x = shot?.x
        const y = shot?.y

        if (x !== undefined && y !== undefined) {
          const clampedX = Math.max(0, Math.min(x, svg.clientWidth))
          const clampedY = Math.max(0, Math.min(y, svg.clientHeight))

          const line = document.createElementNS('http://www.w3.org/2000/svg', 'line')
          line.setAttribute('x1', centerX)
          line.setAttribute('y1', centerY)
          line.setAttribute('x2', clampedX)
          line.setAttribute('y2', clampedY)
          line.setAttribute('stroke', getColorForShot(type.type))
          line.setAttribute('stroke-width', isScorecard ? '6' : '2')

          svg.appendChild(line)
        }
      })
    })
  }

  function getColorForShot(type) {
    switch (type) {
      case '1s':
        return isScorecard ? '#fd9a00' : '#0000FE'
      case '2s':
        return isScorecard ? '#e962ed' : '#00FFFF'
      case '3s':
        return isScorecard ? '#1ebaaf' : '#FEC200'
      case '4s':
        return isScorecard ? '#355eff' : '#FF29FF'
      case '6s':
        return isScorecard ? '#e7604d' : '#FE0000'
      default:
        return 'black'
    }
  }

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${wagonBg.src})`
        }}
        className={`${isScorecard ? styles.scorecard : styles.chartContainer}`}
      >
        <svg
          ref={svgRef}
          preserveAspectRatio="none"
          style={{ height: '400px', width: '400px' }}
          id="wagonWheel"
        ></svg>
      </div>
    </>
  )
}

WagonWheelChart.propTypes = {
  data: PropTypes.object,
  isScorecard: PropTypes.bool
}

export default WagonWheelChart
